import FormCommentReview from './FormCommentReview';
import { VerificationStateEnum } from '@/enums';
import { IHasErrorMessage } from '@/interfaces';

export default FormCommentReview;

export type TFormData = IHasErrorMessage & {
  state: VerificationStateEnum;
  comment: string;
};
